import { Badge } from '@consta/uikit/Badge'
import { Show } from '@library/components'
import type { ClassNameProp, Nullable } from '@library/types'
import type { ProjectState } from 'common/types'
import type { FC } from 'react'

type PublishedProps = ClassNameProp & {
  state: Nullable<ProjectState> | undefined
  isOwned: boolean
}

export const Published: FC<PublishedProps> = ({ className, isOwned, state }) => {
  return (
    <Show when={state === 'Public' && isOwned}>
      <Badge size="s" view="stroked" label="Опубликован" className={className} />
    </Show>
  )
}
